

































import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import "./project-galleries.less";
import ModalGallery from "../modal-gallery/modal-gallery.vue";
import MobileGallery from "../mobile-gallery/mobile-gallery.vue";
import ProjectGalleryDestop from "../project-gallery-destop/project-gallery-destop.vue";
import { getImages } from "../../services/webclient/webclient";


@Component({
    components: {
        ModalGallery,
        MobileGallery,
        ProjectGalleryDestop,
    }
})
export default class ProjectGalleries extends Vue {
    @Prop() galleryId;
    @Prop() galleryNumber;
    @Prop() useThumbnails;
    private data ={
        'index': 0,
        'visible' : false,
        'width' : 0,
    };
    private images = [];
    getWidth(){
        this.data.width = screen.width;
    }
    mounted() {
        //this.initGaleryView();
        this.getWidth();
        this.loadImages();
        try {
            window.addEventListener('resize', this.getWidth);
            window.addEventListener('orientationchange', this.getWidth);
        } catch (e) {

        }
    }
    loadImages(){
        let self = this;
        getImages(this.galleryId).then(function(resp){
            self.images = resp.images;
        })
    }
    showImg (index) {
        this.data.index = index;
        this.data.visible = true;
    };
    handleHide () {
        this.data.visible = false;
    };
    initGaleryView(){
        
        $('#pb-gallery-'+this.galleryNumber).each(function (i, e) {
          let elem: any= $(e);
            let width: any= elem.width();
            elem.height(width * 9 / 16);
        })
        
    }


    @Watch("settingVisible", {immediate: true, deep: true})
    onSettingVisible(visible){
        this.data.visible = visible;
    }

    @Watch("showModalGallery", {immediate: true, deep: true})
    onShowModalGallery(index, visible){
        this.data.visible = visible;
        this.data.index = index;
    }


}
